import { useEffect } from "react";
import type { CurrentOfficeType } from "shared/types/user";

import { isCupidlee, isLatinMelodies } from "shared/constants/envVariables";
import { defaultCurrentOffice } from "shared/constants/user";

import { getCurrentCountry } from "shared/services/user";

const brands = [
  "amourforme",
  "amourlee",
  "cupidlee",
  "latinmelodies",
  "quickmedates",
  "cupidticket",
  "asianforme",
  "interchatify",
  "minglechats",
];

const setPolicyAddress = (
  policyElement: HTMLSpanElement,
  data: CurrentOfficeType
) => {
  if (data.city === "Limassol") {
    policyElement.innerText = `${data.campaign}, ${data.regNumber}, ${data.address}, ${data.city}, ${data.country}`;
  }

  if (data.city === "ST PETERSBURG") {
    policyElement.innerText = `${data.campaign}, Address: ${data.address}, ${data.city}, ${data.state} ${data.index}`;
  }
};

const setTermsAddress = (
  textAddressElement: HTMLSpanElement,
  data: CurrentOfficeType
) => {
  const termsElement = document.querySelectorAll<HTMLParagraphElement>(
    ".terms_company_street"
  );

  if (data.city === "Limassol") {
    const name = `${data.campaign}, ${data.regNumber}, ${data.address}, ${data.city}, ${data.country}`;

    textAddressElement.innerText = `${data.campaign}, a company duly incorporated under the laws of the Republic of ${data.country} with the registration number ${data.regNumber}, having its registered address at ${name}`;

    if (termsElement) {
      termsElement.forEach((element) => {
        element.innerText = name;
      });
    }
  }

  if (data.city === "ST PETERSBURG") {
    const name = `${data.address}, ${data.city}, ${data.state} ${data.index}`;

    textAddressElement.innerText = `${data.campaign}, a company duly incorporated under the laws of the FL with the EIN: 39-2139154 , having its registered address at ${name}, USA`;

    if (termsElement) {
      termsElement.forEach((element) => {
        element.innerText = `${data.campaign}, ${name}`;
      });
    }
  }
};

const setPolicyTermsAddress = (data: CurrentOfficeType) => {
  const policyElements = document.querySelectorAll<HTMLSpanElement>(
    ".privacy_policy_company"
  );
  const policyShortNameElements = document.querySelectorAll<HTMLSpanElement>(
    ".privacy_policy_company_name_short"
  );
  const termsElements = document.querySelectorAll<HTMLSpanElement>(
    ".terms_company_name"
  );

  if (policyElements.length > 0) {
    policyElements.forEach((element) => {
      setPolicyAddress(element, data);
    });
  }

  if (policyShortNameElements.length > 0) {
    policyShortNameElements.forEach((element) => {
      element.innerText = `${data.campaign}`;
    });
  }

  if (termsElements.length > 0) {
    termsElements.forEach((element) => {
      setTermsAddress(element, data);
    });
  }
};

const setAddress = (
  parentElement: HTMLDivElement,
  data: CurrentOfficeType,
  isCupidlee = false
) => {
  setPolicyTermsAddress(data);

  const country =
    data.city === "Limassol"
      ? `<span>${data.city}, ${data.country}</span>`
      : null;
  const state =
    data.city === "ST PETERSBURG"
      ? `<span>${data.city}, ${data.state} ${data.index}</span>`
      : null;
  const addressElement = document.createElement("p");

  addressElement.classList.add("footer_text-global");
  addressElement.classList.add("company_address");

  addressElement.innerHTML = `
    <span>${data.campaign},</span>
    <span>${data.address},</span>
    ${country || state}`;

  if (isCupidlee) {
    addressElement.innerHTML = `
      <span>${data.campaign}</span>
      <span>Registration No.: ${data.regNumber}</span>
      <span>Registered address: ${data.address} ${data.city}, ${data.country}</span>`;
  }

  parentElement.appendChild(addressElement);
};
const useCurrentCountry = () => {
  useEffect(() => {
    const parentElement =
      document.querySelector<HTMLDivElement>(".footer_inner-left");
    const addressElement =
      document.querySelector<HTMLParagraphElement>(".company_address");

    if (
      parentElement &&
      !addressElement &&
      brands.includes(import.meta.env.VITE_APP_MULTI_SITE_IDENTITY)
    ) {
      getCurrentCountry()
        .then(({ data: { data } }) => {
          if (isLatinMelodies) {
            setAddress(parentElement, data as CurrentOfficeType);
            return;
          }

          if (isCupidlee) {
            setAddress(parentElement, defaultCurrentOffice, true);
            return;
          }

          if ((data as CurrentOfficeType).city === "Limassol") {
            setPolicyTermsAddress(data as CurrentOfficeType);
            return;
          }

          setAddress(parentElement, data as CurrentOfficeType);
        })
        .catch(() => {
          if (isLatinMelodies) {
            setAddress(parentElement, defaultCurrentOffice);
          } else if (isCupidlee) {
            setAddress(parentElement, defaultCurrentOffice, true);
          } else {
            setPolicyTermsAddress(defaultCurrentOffice);
          }
        });
    }
  }, []);
};

export default useCurrentCountry;
